import React from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";

import {
  AuthHeadingText,
  SimpleBasic,
  TextBasic,
} from "../components/ThemeComponent/ThemeText";
import { useNavigate } from "react-router-dom";
import { validation, validationText } from "../utils/constants.js";
import { ThemeButton } from "../components/ThemeComponent/ThemeButtons";
import ThemeInput from "../components/ThemeComponent/ThemeInput";
import { errorToast, success } from "../utils/helpers.js";
import { useForgotPasswordMutation } from "../Redux/services/userAuthApi.js";
import ThemeSpinner from "../components/ThemeComponent/ThemeSpinner";
import { useDispatch } from "react-redux";
import { setAuthInfo } from "../Redux/Slice/authSlice";

export default function ForgotPassword() {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleBackButtonClick = () => {
    navigate(-1);
  };
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const onSubmit = async (data) => {
    try {
      const response = await forgotPassword(data);
      if (response.data.code === 200) {
        success(response?.data?.message || "login successfully");
        navigate("/otp-verification");
        dispatch(setAuthInfo({user: data}));
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        errorToast(error?.response?.data?.message, "error");
      } else {
        errorToast("An error occurred during login", "error");
      }
    }
  };

  return (
    <div>
      <div className="d-flex w-100 mt-2">
        <AuthHeadingText
          text="Forgot Password"
          className="mb-2 primary-text fw-bold"
        />
      </div>

      <SimpleBasic
        text="In order to reset your password you need to enter your registered email address."
        className="mb-3"
      />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <ThemeInput
          name="email"
          errors={errors}
          control={control}
          type={"email"}
          className={""}
          placeholder={"Email Address"}
          rules={{
            required: {
              value: true,
              message: validationText.emailRequired,
            },
            maxLength: {
              value: validation.emailMax,
              message: validationText.emailMax,
            },
          }}
        />

        <ThemeButton
          text={isLoading ? <ThemeSpinner /> : "Continue"}
          className="mt-4 mb-2 fw-bold w-100 mt-3"
          type="submit"
          onClick={handleSubmit(onSubmit)}
        />
      </Form>
    </div>
  );
}
